module.exports = {"450802001":"贵城街道","450802002":"港城街道","450802101":"大圩镇","450802102":"庆丰镇","450802103":"根竹镇","450802104":"武乐镇","450802200":"奇石乡","450802201":"中里乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450802.json
// module id = 2129
// module chunks = 0